export const hasRight = (userObj, moduleKey, action = null) => {
    // Sécurité de base
    if (!userObj) return false;

    // 1. Super Admin : Accès à 100%
    if (userObj.role === 'super_admin') return true;

    // 2. Admin : Accès à tout, SAUF à la gestion des utilisateurs
    if (userObj.role === 'admin') {
        return moduleKey !== 'users';
    }

    // 3. Simple Utilisateur : Lecture du JSON
    const rights = userObj.rights || { crud: {}, modules: {} };

    if (action) {
        // Vérification d'un droit CRUD (ex: properties, READ)
        const moduleRights = rights.crud ? rights.crud[moduleKey] : [];
        return moduleRights && moduleRights.includes(action);
    } else {
        // Vérification d'un module Spécial ON/OFF (ex: trash)
        const hasModuleAccess = rights.modules ? rights.modules[moduleKey] : false;
        return hasModuleAccess === true;
    }
};